import { useToast } from "@chakra-ui/react";

interface ToastProps {
  title: string;
  status: "success" | "error" | "warning" | "info" | "loading";
  description?: string;
}

export const Toast = () => {
  const toast = useToast();

  const addToast = ({ title, status, description }: ToastProps) => {
    toast({
      title: title,
      description: description,
      status: status,
      position: "top-right",
      isClosable: true,
      containerStyle: {
        width: "400px",
        maxWidth: "100%",
        mr: "80px",
      },
    });
  };

  return { addToast };
};
